import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import Auth from './layouts/Auth';
import Search from './layouts/Search';
import AIAssistant from './layouts/AIAssistant';

import "./assets/scss/users.scss";
import "./assets/scss/search.scss";

function App() {


  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth/*" element={<Auth />} />
        <Route path="/search/*" element={<Search />} />
        <Route path="/aiassistant/*" element={<AIAssistant />} />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
